export const REDUCER_NAME = 'CAMPAIGNS'

